"use strict";

var PyDefUtils = require("PyDefUtils");
var utils = require("../utils");
const { isInvisibleComponent } = require("@runtime/components/helpers");

module.exports = function(pyModule) {

	pyModule["DesignFlowPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        var properties = PyDefUtils.assembleGroupProperties([]);

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["FlowPanel"].prototype["__init__"], undefined, undefined, kwargs, self);

            self._anvil.gutter = $(self._anvil.elements.gutter)

            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY) {

                let items = self._anvil.gutter.children();

                // First find all the elements on the line we're over
                let thisLineItems = items.filter((i,e) => $(e).offset().top < mouseY && ($(e).offset().top + $(e).outerHeight() >= mouseY));

                // Now find the elements before and after our position
                let before = thisLineItems.filter((i,e) => ($(e).offset().left + $(e).outerWidth()/2) < mouseX).last();
                let after = thisLineItems.filter((i,e) => $(e).offset().left + $(e).outerWidth()/2 >= mouseX).first();
                
                let idx, insertPos;

                if (items.length == 0) {
                    // No components
                    idx = 0;
                    insertPos = utils.positionOf(self._anvil.element);
                } else if (after.length > 0 && before.length > 0) {
                    // Between two
                    idx = items.index(after);
                    insertPos = { x: (before.offset().left + before.outerWidth() + after.offset().left)/2, y: after.offset().top, width: 0, height: after.outerHeight() };
                } else if (after.length > 0) {
                    // Beginning of line
                    idx = items.index(after);
                    insertPos = { x: after.offset().left, y: after.offset().top, width: 0, height: after.outerHeight() };
                } else if (before.length > 0) {
                    // End of line
                    idx = items.index(before) + 1;
                    insertPos = { x: before.offset().left + before.outerWidth(), y: before.offset().top, width: 0, height: before.outerHeight() };
                } else {
                    // No idea. Drop at the end.
                    idx = items.length;
                    insertPos = utils.positionOf(self._anvil.element);
                }

                let rtn = {
                    childIdx: idx,
                    layoutProperties: {},
                    estimatedPosition: insertPos,
                };

                let [distance, nearest] = utils.distanceToEdge(self._anvil.element, mouseX, mouseY);

                if (distance < Math.min(15, this.element.outerHeight() / 3)) {
                    rtn['redirectToElement'] = self._anvil.element.parent().closest(".anvil-container")
                }

                return rtn;                
            };

            self._anvil.setLayoutProperties = function(pyChild, props) {
                const elt = $(pyChild.anvil$hooks.domElement);
                const layoutProps = {};

                if ("width" in props) {
                    // we're updating the width - so we shouldn't be expandable.
                    const width = props.width;
                    if (elt.hasClass('anvil-inlinable') || width === null) {
                        elt.parent().css({ flex: "", width: "" });
                        layoutProps.width = null;
                    } else {
                        elt.parent().css({ flex: "", width: props.width });
                        layoutProps.width = +width;
                    }
                    layoutProps.expand = false;
                } else if ("expand" in props) {
                    // we're changing expand - so width should be removed
                    const expand = props.expand;
                    elt.parent().css({ flex: expand ? "1" : "", width: "" });
                    layoutProps.expand = expand;
                    if (expand) {
                        // we shouldn't have a width if expand has changed to false
                        // maybe a bad yaml
                        layoutProps.width = null;
                    }
                }

                return { [pyChild._anvil?.componentSpec?.name]: layoutProps };
            };

            self._anvil.getHandles = function(pyChild) {
                if (isInvisibleComponent(pyChild)) return [];

                if (pyChild && !pyChild.anvil$hooks.domElement.classList.contains('anvil-inlinable') && !pyChild.anvil$hooks.domElement.parentElement.style.flex) {
                    // Get layout handles for pyChild
                    var e = $(pyChild.anvil$hooks.domElement)
                    var offset = e.offset();
                    var w = e.outerWidth();
                    var h = e.outerHeight();

                    return [{
                        x: offset.left + w,
                        y: offset.top + h/2 - 5,
                        width: 10,
                        height: 10,
                        cursor: "ew",
                        childName: pyChild._anvil?.componentSpec?.name,
                        owner: self._anvil?.componentSpec?.name,
                    }];
                }
                return [];
            }

            self._anvil.handleGrab = function(handle, mouseX, mouseY) {
                // This is a layout handle for one of our children
                const $el = $(handle.pyChild.anvil$hooks.domElement);
                const originalWidthProp = parseFloat(handle.pyChild._anvil?.componentSpec?.layout_properties?.width || $el.outerWidth())
                return {
                    mouseX,
                    originalHandleX: handle.x,
                    originalWidth: $el.parent().width(),
                    originalEltWidth: $el.width(),
                    originalWidthProp,
                };
            };

            self._anvil.handleDrag = function(handle, grab, mouseX, mouseY) {
                // This is a layout handle for one of our children
                var totalDx = mouseX - grab.mouseX;
                handle.x = grab.originalHandleX + totalDx;
                // NB we drag the component, not its inline container,
                // which avoids nasty reflows during resize
                const $el = $(handle.pyChild.anvil$hooks.domElement);
                $el.width(grab.originalEltWidth + totalDx);
                return handle;
            }

            // TODO: See comment on same function in DesignRichText.
            self._anvil.handleDrop = function(handle, grab, mouseX, mouseY) {
                var totalDx = mouseX - grab.mouseX;
                var newWidth = grab.originalWidthProp+totalDx;
                const $el = $(handle.pyChild.anvil$hooks.domElement);

                $el.css("width", "");
                $el.parent().css("width", newWidth)

                var r = { layoutProperties: {}};
                r.layoutProperties[handle.pyChild._anvil?.componentSpec?.name] = {
                    width: newWidth,
                };

                return r;
            }
        }));
    }, "DesignFlowPanel", [pyModule["FlowPanel"]]);
};
